import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../api/client';
import { endpoints } from '../../../api/endpoints';
import { queryKeys } from '../../../api/queryKeys';
import type { CustomerBookingHistoryResponse } from '../../../types/api';

export function useCustomerBookings(uuid: string, page: number) {
  return useQuery({
    queryKey: [...queryKeys.customers.bookings(uuid), page] as const,
    queryFn: async () => {
      const res = await apiClient.get<CustomerBookingHistoryResponse>(
        `${endpoints.customers.bookings(uuid)}?page=${page}`,
      );
      return res.data;
    },
    staleTime: 30_000,
    enabled: Boolean(uuid),
  });
}
